import { updateLinksAttributes } from '../utils/handleAttributes';

export default function customTicketBtn() {
  const widgetName = 'customTicketBtn';
  const widgetOpts = customTicketBtnOpts;
  const $widget = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    itemsPerPanel: 1,
    maxItemsVisible: 1,

    cardWidgetLoaded: function (data, _owl, hasData) {
      const ticketItem = data.items[0];

      if (hasData && ticketItem.URL != null) {
        createCustomTicketBtn(ticketItem);
      } else {
        $('body').addClass('customTicketBtn-no-data');
        $widget.remove();
      }
    },
  });

  function createCustomTicketBtn(widgetData) {
    const $item = $widget.find('.card-widget-item');
    const { Title, URL } = widgetData;

    $item.replaceWith(
      `<a href="${URL}" class="header-btn button" ${updateLinksAttributes(URL, Title)}>
        <span class="btn-label">${Title}</span>
      </a>`,
    );
  }
}
